import React from 'react';
import { Snowflake } from 'lucide-react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="hero-icon">
          <Snowflake size={80} strokeWidth={1.5} />
        </div>
        <h1 className="hero-title">
          Willkommen bei Frost Studio
        </h1>
        <p className="hero-subtitle">
          Ihre effiziente Lösung für Oberflächenreinigung durch Trockeneisstrahlen
        </p>
        <p className="hero-description">
          Professionelle Reinigungslösungen für Industrie, Produktion und mehr.
          Umweltfreundlich, rückstandsfrei und hocheffizient.
        </p>
      </div>
      <div className="hero-background"></div>
    </section>
  );
};

export default HeroSection;